module.exports = __webpack_public_path__ + "static/media/206-gallery10.351c1988.jpg";